import { createReducer } from './Reducer';
import { ExprValue } from '../../ExprValue';
export const min = createReducer((curr, next) => {
    return ExprValue.lt(curr, next) ? curr : next;
});
